module.exports = __webpack_public_path__ + "static/media/graph_118.7f59bed0.png";